import React, { useEffect, useRef, useState } from 'react';
import closeIcon from '../../assets/images/icon/close.png';
import useAlert from '../../hooks/useAlert';
import useOnClickOutside from  '../../hooks/useOnClickOutside';
 
type Props = {
  search: (keyword:string) => void;
  reset: () => void;
};

function ImageLibraryInput({ search, reset }: Props) {
  const [keyword, setKeyword] = useState('');
  const [history, setHistory] = useState([] as string[]);
  const [showHistory, setShowHistory] = useState(false);
  const STORAGE_KEY = 'stb_editor_image_library_history';

  const containerRef = useRef(null);
  const inputRef:any = useRef(null);

	useOnClickOutside(containerRef, ():any => {
		setShowHistory(false);
  });

  useEffect(() => {

    if (inputRef.current) {
      inputRef.current.focus();
    }

    const history:string|null = localStorage.getItem(STORAGE_KEY);
    setHistory(history === null ? [] : history.split(','));
  }, []);

  const handleChangeKeyword = (e:any) => {		
    setKeyword(e.target.value);    
  }

  const handleKeypress = (e:any) => {
    if (e.key === 'Enter') {
      search(keyword);
      saveHistory(keyword);
      setShowHistory(false);
      inputRef?.current?.blur();
    }
  }

  const saveHistory = (keyword:string) => {
    let h = [...history];
    if (!h.includes(keyword)) {
      h.unshift(keyword);
    }
    const nh = h.slice(0, 5);
    setHistory(nh);
    localStorage.setItem(STORAGE_KEY, nh.join(','));
  }

  return (
    <>
    <div className="keyword" ref={containerRef}>
      <div className="input">
        <input
          type="text"
          ref={inputRef}
          value={keyword}
          onChange={handleChangeKeyword}
          onKeyPress={handleKeypress}
          onFocus={() => {setShowHistory(true)}}
        />
        {
          (keyword.length !== 0 && showHistory) && (
            <button className="close" onClick={() => {reset(); setKeyword('')}}>
              <img src={closeIcon} alt="닫기" />
            </button>
          )
        }
      </div>
      {
        showHistory && (
          <div className="keyword-history">
            <h2>최근 검색 기록</h2>
            <ul>
              {
                history.map((item:any, index:number) => (
                  <li key={index}>
                    <button onClick={() => {search(item); setKeyword(item); setShowHistory(false)}}>{item}</button>
                  </li>
                ))
              }
            </ul>
          </div>
        )
      }
    </div>
    </>
  );
}

ImageLibraryInput.defaultProps = {
};

export default ImageLibraryInput;